module.exports = __webpack_public_path__ + "static/media/ms.c9c8b50a.svg";